module.exports = __webpack_public_path__ + "public/media/emtelak.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/emtelak.png
// module id = ./images/partners/emtelak.png
// module chunks = 0